import {createContext } from "react";

const DataConfig = createContext();

export default DataConfig;